String.prototype.beginsWith = function(s, caseSensitive)
{
    if (caseSensitive === undefined) caseSensitive = true;
    return caseSensitive ?
      (s == this.substring(0, s.length)) :
      (s.toLowerCase() == this.substring(0, s.length).toLowerCase());
};

String.prototype.endsWith = function(s, caseSensitive)
{
    if (caseSensitive === undefined) caseSensitive = true;
    return caseSensitive ?
      (s == this.substring(this.length - s.length)) :
      (s.toLowerCase() == this.substring(this.length - s.length).toLowerCase());
};
